import React, { useState } from 'react'
import { useGetServiceListQuery } from '../../../store/cmsService'
import { Interest, TagIconMap } from '../types'
import InterestTile from './InterestTile'
import ServiceLinesIconMapper from './ServiceLinesIconMapper'

interface ServiceLineSelectorProps {
  defaultSelected?: number[]
  onChange: (value: number[]) => void
}

const ServiceLineSelector = ({
  defaultSelected = undefined,
  onChange,
}: ServiceLineSelectorProps) => {
  const { data } = useGetServiceListQuery()
  const [selected, setSelected] = useState<number[]>(defaultSelected ?? [])
  const tagIconMap: TagIconMap = ServiceLinesIconMapper()

  const interests = data?.data?.map((interest) => {
    const tag = interest.tag?.split('/')?.pop()
    return tag ? { ...interest, icon: tagIconMap[tag] } : interest
  }) as Interest[]

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {interests?.map((interest, index) => (
        <InterestTile
          key={interest.tag}
          testId="ServiceLine"
          checked={selected.includes(interest.id)}
          index={index}
          interest={interest}
          onClick={(checked) => {
            const value = checked
              ? [...selected, interest.id]
              : selected.filter((i) => i !== interest.id)
            setSelected(value)
            onChange(value)
          }}
        />
      ))}
    </>
  )
}

export default ServiceLineSelector
